import { getAxios } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { logger } from '@/infrastructure/logger';
import { getProductId } from '@/infrastructure/product-info';

const axios = getAxios();

export type TagInfo = {
  tagCount?: number;
  tagId?: string;
  tagName?: string;
  tagType?: number;
  tagColor?: string;
};

export const getTagList = async (): Promise<TagInfo[]> => {
  try {
    const res = await axios.get(`/${API_PREFIX}/api/tag/list?appId=${getProductId()}`);
    return res.data.unsystemTagArr;
  } catch (e) {
    logger.error('getTagList e:', e);
    return [];
  }
};

export const addTag = async (tagName: string, tagColor: string) => {
  try {
    return await axios.post(`/${API_PREFIX}/api/tag/add`, {
      appId: getProductId(),
      tagName,
      tagColor,
    });
  } catch (e) {
    logger.error('addTag', e);
    return null;
  }
};

export const deleteTag = async (tagId: string) => {
  try {
    return await axios.get(`/${API_PREFIX}/api/tag/delete?appId=${getProductId()}&tagId=${tagId}`);
  } catch (e) {
    logger.error('deleteTag e:', e);
    return null;
  }
};

export const updateTag = async (tagId: string, tagName: string, tagColor: string) => {
  try {
    return await axios.post(`/${API_PREFIX}/api/tag/update`, {
      appId: getProductId(),
      tagId,
      tagName,
      tagColor,
    });
  } catch (e) {
    logger.error('updateTag e:', e);
    return null;
  }
};
